import { TodoIntegrationType, SupportedTerraSDKType, ScheduleLogicElement } from '@demind-inc/core';
import { TaskFilterOptions } from './types';

export const AVAILABLE_TODO_INTEGRATIONS_TYPE: TodoIntegrationType[] = [
  'todoist',
  'trello',
  'ticktick',
  'clickup',
  'notion',
  'github',
  'google-tasks',
  'apple-reminders',
];

export const DEFAULT_FREE_TRIAL_DAYS = 7;
export const MONTH_FREE_TRIAL_DAYS = 30;

export const basicOfferingId = 'basic (with free trial)';
export const basicLifetimeOfferingId = 'basic (lifetime)';

export const terraSdkNames: SupportedTerraSDKType[] = [
  'APPLE',
  'FREESTYLE_LIBRE',
  'GOOGLE_FIT',
  'SAMSUNG_HEALTH',
];

export const TASK_FILTER_ALL_LABEL_KEY = 'lifestack_all';

export const defaultTaskFilterOptions: TaskFilterOptions = {
  labelNames: TASK_FILTER_ALL_LABEL_KEY,
  hideNoDueDate: false,
  onlyMyTask: false,
};

export const scheduleLogicAllElements: ScheduleLogicElement[] = ['timebox', 'routine', 'task'];

export const SKIP_CARD_PRODUCT_ID = 'com.lifestack.skip_card';

export const DEFAULT_TASK_DURATION_MIN = 30;

export const MANUAL_SLEEP_DATA_DEVICE_NAME = 'Manual(Lifestack)';
